import GLOBAL from '../util/global';
import Core from './core';
import { InitOption } from './types/core.type';

let singleton: Core = null;

function init(opts?: InitOption): Core {
    if (!singleton) {
        singleton = new Core(opts);
    }

    return singleton;
}

!((win) => {
    win.Prajna = init();
})(GLOBAL); // tslint:disable-line



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/core/index.ts